import Vue from 'vue'
import Router from 'vue-router'
import PromptTool from '@/components/PromptTool'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'PromptTool',
      component: PromptTool
    }
  ],
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js